module.exports = __webpack_public_path__ + "img/empresas.f31725b6.svg";